export enum SortOrder {
	Ascending,
	Descending
}

export enum SortCategory {
	Played,
	Received
}

export enum Layout {
	None,
	Admin,
	Panel,
	Tip,
	Default,
	Onboard
}
